<template>
    <span>
        <!-- 处理dataType的情况 -->
        <template v-if="formItem.dataType === 'time'">
            {{ $timetransition(model[formItem.index]) }}
        </template>
        <!-- 处理convert的情况 -->
        <template v-else-if="formItem.convert">
            {{ formItem.convert[model[formItem.index]] && $t(formItem.convert[model[formItem.index]].title) }}
        </template>
        <template v-else> {{ model[formItem.index] }} </template>
    </span>
</template>

<script>
export default {
    props: ['formItem', 'model']
};
</script>

<style></style>
